export const AUTH_TOKENS_LOCAL_STORAGE_KEY = 'AUTH_TOKENS';
export const ROLE_TYPE = '_rt';

export const MFA_TOKENS_LOCAL_STORAGE_KEY = 'MFA_TOKENS';
